/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { reactBootstrapLoader } from "abreact/incubator/ui/app/bootstrap/ReactBootstrapLoader";
import { reactAuthenticationStrategy } from "abreact/incubator/ui/login/ReactAuthenticationStrategy";
/**
 * Strategy that uses ReactBootstrapLoader to load the react app skeleton used during app loading,
 * then invokes reactAuthenticationStrategy for authentication worklflow (also initialized abweb and abreact servies)
 * then invokes startApp to finish loading the application and returning the rendering function.
 * @param props
 */
export function bootstrapAndAuth(props) {
  // Calc default values for optional props
  const containingNodeSelector = props.containingNodeSelector ?? "#appGoesHere";
  const absdkDirPrefix = props.absdkDirPrefix !== undefined ? props.absdkDirPrefix : "";
  const headless = props.headless !== undefined ? props.headless : false;
  const containingElem = document.querySelector(containingNodeSelector);
  if (!(containingElem instanceof HTMLElement))
    // eslint-disable-line abinitio/no-instanceof
    {
      throw new Error(`Unable to retrieve HTMLElement for containingNodeSelector: '${containingNodeSelector}'`);
    }
  const containingNode = containingElem;
  function defaultAuthenticationStrategy(alProps) {
    const preloadSpecs = props.preloadSpecs ?? [];
    const alwaysPreloadLastSpec = props.alwaysPreloadLastSpec !== undefined ? props.alwaysPreloadLastSpec : false;
    const abReactServicesConfig = props.abReactServicesConfig ?? {};
    return reactAuthenticationStrategy(alProps, props.requiredLoginRole, preloadSpecs, props.loginDialogShowProductName, props.loginDialogAlternateImage, alwaysPreloadLastSpec, props.abWebServicesConfig, abReactServicesConfig, props.preAuthHook, props.portalLoginView);
  }
  async function authenticateThenStartApp(alProps) {
    if (props.customErrorHandlers) {
      props.customErrorHandlers.forEach(errHandler => alProps.errorContextPipeline.addErrorHandledListener(errHandler));
    }
    await (props.customAuthenticationStrategy ? props.customAuthenticationStrategy(alProps) : defaultAuthenticationStrategy(alProps));
    // Now that we're authenticated, start up the app
    return props.startApp(alProps);
  }
  return reactBootstrapLoader(authenticateThenStartApp, containingElem, absdkDirPrefix, headless, props.portalLoginView);
}
//# sourceMappingURL=ReactBootstrapAndAuthStrategy.js.map
